import { render, staticRenderFns } from "./Scene5.vue?vue&type=template&id=1ed9e3a8&scoped=true"
import script from "./Scene5.vue?vue&type=script&lang=js"
export * from "./Scene5.vue?vue&type=script&lang=js"
import style0 from "./Scene5.vue?vue&type=style&index=0&id=1ed9e3a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed9e3a8",
  null
  
)

export default component.exports